import { PharmacyInfo } from './pharmacy'
import { PatientPlan } from './patient'

export class Intake {
    intakeId: number;
    visitType: string;
    hipaaConsentedOn: Date;
    userId: number;
    currentState: string = '';
    chiefComplaint: string = '';
    contactEmail: string;
    contactPhoneNumber: string;
    firstName: string;
    middleName: string;
    lastName: string;
    dob: Date;
    gender: string;
    ipAddress: string;
    deviceType: string;
    createdBy: string;
    userPolicyId: number;
    personalConditions: string;
    reasonForVisit: string;
    planCode: string;
    pharmacy: PharmacyInfo;
    plans: PatientPlan[];
    intakeStatus: string;
    // VideoSessionId: string;
    // VideoTokenId: string;
    videoSessionId: string;
    videoTokenId: string;
    lineOfBusiness: string;
    selectedPlanId:number;
    recordReleaseConsent: boolean;
    TreatmentConsent: string;
    PrivacyPracticesConsent: string;
    FinancialResponsibilityAssignmentConsent: string;
    TermsAndConditionsConsent: string;
}

export class ServerIntake {
    intakeId: number
    intakeStatus: string
    IntakeDate: Date
    intakeDate: Date
    uniqueId: string
    intakeAccessUrl: string
}

export class IntakeMedicationData {
    intakeId: number;
    medicationName: string;
}

export class IntakeAllergyData {
    intakeId: number;
    allergenName: string;
}

export class ScheduleRequest {
    patientId: number;
    requestedAppointmentDate: string;
    requestedProviderId: number;
    providerId: number;
    visitTypeRequested: String;
    specialtyType: string;
    
}
export class ScheduleReservation {
    patientId: number;
    providerId: number;
    scheduleId: number;
    appointmentDate: Date;     
    requestId: number;
}
export class ScheduleResponse {
    intakeId: number;
    requestedById: number;
    dateRequested: Date;
    requestedAppointmentDate: Date;
}
export class RequestVerification {
    request: number;
    requestCount: number;
    isValid: boolean;
}
export class SatrtAssignRequestJob {
    appointmentDate: Date;
    intakeId: number;
    providerId: number;
    url: string;
    verb: string;
}
export class PatientScheduledVisits {
    intakeId: number;
    userID: number;
    chiefComplaint: string;
    gender: string;
    intakeDate: Date;
    providerName: string;
    intakeStatus: string;
    intakeState: string;
    patientName: string;
    lineOfBusiness: string;
    startDate: Date;
    originatingScheduleId: number;
    scheduleId: number;
    scheduleAvailabilityType: string;
    scheduleDescription: string;
    visitType: string;
    group: string;
    dateRequested: Date;
    visitRequestedAppointmentDateType: Date;
    requestedAppointmentDate: Date;
    serviceLine: string;
}

export class PatientScheduleIntakeData {
    OriginatingScheduleId: number;
    StartDate: Date;
    EndDate: Date;
    IntakeId: number;
    ProviderUserId: number;
}
export class ScheduledBhVisit
{
    startDate: Date;
    endDate: Date;
    stateAbbr: string;
    lineOfBusiness: string;
     availabilityType: string;
     newAvailableDescription: string;
     newAvailableEventType: string;
     specialtyType: string;
    intakeId: number;
    scheduleId: number;
    availabilityId: number;
    providerId: number;
    patientId: number;
}

export class VisitSchedule {
    intakeId?: number;
    requestedById?: number;
    dateRequested?: Date;
    requestedAppointmentDate?: Date;
    patientId?: number;
    providerId?: number;
    isScheduled?: boolean;
    appointmentDate?: Date;
}

export class MediaPermisionData {
    intakeId: number;
    userId: number;
    meMDUserType: string;
    videoSession: string;
    videoToken: string;
    hasWebCam: boolean;
    hasMicrophone: boolean;
    hasSpeakers: boolean;
    isWebRTCSupported: boolean;
    isMobileDevice: boolean;
    isWebSocketsBlocked: boolean;
    isWebsiteHasWebcamPermissions: boolean;
    isWebsiteHasMicrophonePermissions: boolean;
    isVideoSupportsStreamCapturing: boolean;
    isPrivateBrowsing: boolean;
    audioInputDevices: string;
    audioOutputDevices: string;
    videoInputDevices: string;
    browserName: string;
    browserVersion: string;
    meMDApplication: string;
    meMDApplicationVersion: string;
}
export class LabworkRequestModel {
    IntakeId: number;
    LabworkRequested: boolean;
    RequestedDate: Date;
    RequestedById: number;
    RequestingPhysicianId: number;
    RequestStatus: string;
    RequestedByDept: string;
    AdditionalNotes: string;
}
export class LabworkRequestSubmission {
    IntakeId: number;
    RequestedById: number;
    RequestingPhysicianId: number;
    RequestStatus: string;
    RequestedByDept: string;
    AdditionalNotes: string;
}
